const timePickerStyles = (theme) => ({
  typeahead: {
    display: 'inline-block',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '24px',
    width: '100%',
    position: 'relative',
  },
  typeahead_header: {
    position: 'relative',
  },
  validatedTextField: {
    position: 'relative',
  },
  inputProps: {
    marginTop: '-6px',
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.65)',
  },
  typeahead_options: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 102,
    overflow: 'hidden',
    padding: 0,

    boxShadow: '0 2px 5px 0 rgba(0,0,0,0.16), 0 1px 6px rgba(0,0,0,0.12)',
    borderRadius: '2px',
    '& $optionList': {
      maxHeight: '220px',
    },
  },
  optionList: {
    backgroundColor: '#fff',
    color: '#0c0d0d',
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'relative',
    padding: '8px 0',
    '& ul': {
      padding: 0,
    },
  },
  optionListItem: {
    fontSize: '13px',
    fontWeight: 400,

    overflow: 'hidden',
    cursor: 'pointer',
    lineHeight: '20px',
    padding: '10px 20px',
    position: 'relative',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#20a',
    },
  },
});

export default timePickerStyles;
